// @flow
import React from 'react';
// Styles
import './TermsOfUsagePage.css';
// Components
import { PageTitleWithGoBack } from '../../common';
import { Helmet } from 'react-helmet';

const DriverAppTermsOfUsagePage = () => {
  return (
    <div className="terms-main">
      <Helmet>
        <title>
          Driver App | Termos de Uso - Bigdelivery, Seu açougue virtual
        </title>
      </Helmet>

      <PageTitleWithGoBack title="Política De Privacidade — Big Delivery Driver App" />
      <div className="terms-main-text">
        <p>
          <b>1. SOBRE ESTE APLICATIVO</b>
        </p>

        <p>
          O Big Delivery Driver App é um aplicativo de uso operacional interno,
          destinado exclusivamente aos motoristas cadastrados pela BIG DELIVERY
          ECOMMERCE DE ALIMENTOS LTDA. O cadastro de usuários é realizado
          diretamente pela empresa por meio de sistema administrativo interno,
          não sendo disponibilizada funcionalidade de criação, alteração ou
          exclusão de conta pelo próprio usuário no aplicativo.
        </p>

        <p>
          <b>2. DADOS COLETADOS</b>
        </p>

        <p>
          O aplicativo coleta exclusivamente:
          <ul>
            <li>
              <b>Localização em tempo real</b>, para monitoramento de rotas e
              acompanhamento de entregas
            </li>
            <li>
              <b>Dados de atividade física</b>, para fins operacionais de
              acompanhamento de jornada
            </li>
            <li>
              <b>Acesso à câmera</b>, utilizado para funcionalidades
              operacionais internas
            </li>
          </ul>
          Nenhum dado cadastral é coletado diretamente pelo aplicativo.
        </p>

        <p>
          <b>3. USO DOS DADOS</b>
        </p>

        <p>
          Os dados coletados são utilizados exclusivamente para fins
          operacionais internos da BIG DELIVERY ECOMMERCE DE ALIMENTOS LTDA.,
          incluindo monitoramento de entregas, otimização de rotas e gestão de
          jornada. Nenhum dado é compartilhado com terceiros.
        </p>

        <p>
          <b>4. RETENÇÃO DE DADOS</b>
        </p>

        <p>
          Os dados coletados são mantidos pela BIG DELIVERY ECOMMERCE DE
          ALIMENTOS LTDA. pelo tempo necessário ao cumprimento das finalidades
          operacionais e de obrigações legais, fiscais e contratuais, nos termos
          da legislação brasileira aplicável, incluindo a Lei Geral de Proteção
          de Dados (Lei nº 13.709/2018 – LGPD).
        </p>

        <p>
          <b>5. DIREITOS DO USUÁRIO</b>
        </p>
        <p>
          Solicitações relacionadas aos dados pessoais, incluindo acesso,
          correção ou exclusão, deverão ser direcionadas à BIG DELIVERY
          ECOMMERCE DE ALIMENTOS LTDA. pelo endereço eletrônico{' '}
          <a
            href="mailto:sac@bigdelivery.com.br"
            target="_blank"
            rel="noreferrer"
          >
            sac@bigdelivery.com.br
          </a>
          .
        </p>
        <p>
          <b>6. CONTATO</b>
        </p>

        <p>
          BIG DELIVERY ECOMMERCE DE ALIMENTOS LTDA. Rua Santo Antônio, n. 50,
          Bairro Portão, Lauro de Freitas – Bahia{' '}
          <a
            href="mailto:sac@bigdelivery.com.br"
            target="_blank"
            rel="noreferrer"
          >
            sac@bigdelivery.com.br
          </a>
        </p>
      </div>
    </div>
  );
};

export default DriverAppTermsOfUsagePage;
